var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-toolbar",
    {
      staticClass: "header header--padding-left",
      attrs: { app: "", fixed: "", color: "white" }
    },
    [
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-start": "",
            row: "",
            "fill-height": ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { grow: "" } },
            [
              _vm.showBackBtn
                ? _c(
                    "v-btn",
                    {
                      attrs: { flat: "", icon: "", color: "primary" },
                      on: {
                        click: function($event) {
                          _vm.goBack()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { size: "32" } }, [
                        _vm._v("arrow_back")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "mr-2", attrs: { xs5: "" } },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { shrink: "" } },
            [
              _c(
                "header-notifications",
                {
                  attrs: { visible: _vm.dtNotificationVisible },
                  on: {
                    "update:visible": function($event) {
                      _vm.dtNotificationVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "v-badge",
                    {
                      attrs: {
                        color: "secondary",
                        right: "",
                        bottom: "",
                        overlap: ""
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { fab: "", small: "", color: "white" },
                          on: {
                            click: function($event) {
                              _vm.dtNotificationVisible = true
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("icon-notification")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.unreadNumber > 0
                        ? _c(
                            "span",
                            {
                              staticClass: "whitePure--text",
                              attrs: { slot: "badge" },
                              slot: "badge"
                            },
                            [_vm._v(_vm._s(_vm.unreadNumber))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { shrink: "" } },
            [
              _c(
                "v-menu",
                { attrs: { "offset-y": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        slot: "activator",
                        fab: "",
                        small: "",
                        color: "white"
                      },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", { attrs: { color: "primary" } }, [
                        _vm._v("icon-profile")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-tile",
                        { attrs: { to: "/profile" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("icon-profile")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  _vm._s(_vm.$t(_vm.lblSetting.lblProfile))
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { on: { click: _vm.handleSignOut } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [
                              _c("v-icon", { attrs: { color: "red" } }, [
                                _vm._v("settings_power")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  _vm._s(_vm.$t(_vm.lblSetting.lblSignOut))
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9dac75a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9dac75a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/header/template.html
// module id = null
// module chunks = 